export default function useAdminUrl() {
    const localePath = useLocalePath();

    const urlParams = computed(() => {
        if (import.meta.server) {
            const { ssrContext } = useNuxtApp();

            return getSsrUrlParams(ssrContext);
        }

        const { params } = useRoute();
        return params;
    });

    // computed urlPath helper
    const teamPath = computed(() =>
        localePath(`/admin/${urlParams.value.team}`),
    );
    const urlPath = computed(() =>
        localePath(`/admin/${urlParams.value.team}/${urlParams.value.product}`),
    );

    const hasTeamOrProduct = computed(() => {
        return (
            [urlParams.value.team, urlParams.value.product].filter(
                (value) => value,
            ).length > 1
        );
    });

    // TODO maybe use profile?
    const navigateToTeam = async (teamUuid, path = null) => {
        return await navigateToAdmin(teamUuid, urlParams.value.product, path);
    };

    const navigateToProduct = async (productUuid, path = null) => {
        return await navigateToAdmin(urlParams.value.team, productUuid, path);
    };

    const navigateToAdmin = async (teamUuid, productUuid, path = null) => {
        const localizedBase = localePath(`/admin/${teamUuid}/${productUuid}`);

        if (path) {
            return await navigateTo(`${localizedBase}/${path}`);
        }

        return await navigateTo(localizedBase);
    };

    return {
        urlParams,
        teamPath,
        urlPath,
        hasTeamOrProduct,

        navigateToTeam,
        navigateToProduct,
        navigateToAdmin,
    };
}
